    /* eslint-disable react/jsx-pascal-case */
    import { message, Button, Col, ConfigProvider, Form, Tag, Row, Tabs, Space, Radio, Modal, Popconfirm, InputNumber, Switch, Spin } from "./../../ui/ot";
    import React, { useContext, useEffect, useRef, lazy, Suspense, useState } from "react";
    import { useEditorMessage } from "../controller/EditorMessageController";
    import { ProTableOt as ProTableOT } from "../../ui/ot";

    import NewsForm from "./NewsForm";

    const setParamsFilter = (obj) => {
        //拿掉值為空或是null 的東西
        return Object.entries(obj).reduce((all, [key, value]) => value === "" ? { ...all } : { ...all, [key]: value }, {})
    }

    const EditorMessage = ({
        defaultSize = 20,
        showSwitch = false,
        showNewsType = false,
        propsShowColumns = ['editor_message_id', 'editor_message', 'last_edit_time', 'option'],
        propsCheckSelectRowKeys = [],
        propsCheckSelectedRowsInfo = [],
        propsMode = true,
        onCheckSelectChange = () => { },
        onClickEditNewsType = () => { }
    }) => {

        const actionRef = useRef();

        const [form] = Form.useForm();

        const [pageSize, setPageSize] = useState(defaultSize ? defaultSize : 20)
        const [selectedRowKeys, setSelectedRowKeys] = useState([])
        const [selectedRowsInfo, setSelectedRowsInfo] = useState([])
        const [modalOpen, setModalOpen] = useState(false)
        const [modalLoading, setModalLoading] = useState(false)
        const [axiosMode, setAxiosMode] = useState("get")

        const handleAddRow = () => {
            setAxiosMode("post")
            setModalOpen(true)
            form.resetFields()
        }

        const handleEditRow = (record) => {
            setAxiosMode("patch")
            setModalOpen(true)

            form.resetFields()
            form.setFieldsValue({
                ...record,
            })
        }

        const handleDeleteRow = (id) => {
            let data = []
            if (id) {
                data = [{
                    editor_message_id: id
                }]
            }

            else {
                data = selectedRowsInfo.map((val) => {
                    return {
                        editor_message_id: val?.editor_message_id
                    }
                })
            }
            if (data.length > 0) {
                deleteEditorMessageData(data)
            }
            else {
                message.info("請選擇項目")
            }
        }

        const onCleanSelected = () => {
            if (mode) {
                setSelectedRowKeys([])
                setSelectedRowsInfo([])
            }
            else {
                setcheckSelectedRowKeys([])
                setcheckSelectedRowsInfo([])
            }
    
        }

        const [checkSelectedRowKeys, setcheckSelectedRowKeys] = useState(propsCheckSelectRowKeys)
        const [checkSelectedRowsInfo, setcheckSelectedRowsInfo] = useState(propsCheckSelectedRowsInfo)
        const rowSelection = {
            //不一定都是對id
            onSelectAll: (selected, selectedRows, changeRows) => {
                let select_temp = []
                let selectRow = []
                if (mode) {
                    select_temp = [...selectedRowKeys]
                    selectRow = [...selectedRowsInfo]
                }
                else {
                    select_temp = [...checkSelectedRowKeys]
                    selectRow = [...checkSelectedRowsInfo]
                }
                if (selected) {
                    changeRows.map((value, key) => {
                        select_temp.push(value.editor_message_id)
                        selectRow.push(value)
                    })
    
                }
                else {
                    changeRows.map((value, key) => {
                        const index = select_temp.indexOf(value.editor_message_id);
                        select_temp.splice(index, 1);
                        selectRow.splice(index, 1);
    
                    })
                }
                if (mode) {
                    setSelectedRowKeys(select_temp)
                    setSelectedRowsInfo(selectRow)
                }
                else {
                    setcheckSelectedRowKeys(select_temp)
                    setcheckSelectedRowsInfo(selectRow)
                    onCheckSelectChange(select_temp, selectRow)
                }
            },
            onSelect: (record, selected, selectedRows, nativeEvent) => {
                let select_temp = []
                let selectRow = []
                if (mode) {
                    select_temp = [...selectedRowKeys]
                    selectRow = [...selectedRowsInfo]
                }
                else {
                    select_temp = [...checkSelectedRowKeys]
                    selectRow = [...checkSelectedRowsInfo]
                }
                if (selected) {
                    select_temp.push(record.editor_message_id)
                    selectRow.push(record)
                }
                else {
                    select_temp = select_temp.filter(key => key !== record.editor_message_id)
                    selectRow = selectRow.filter(row => row.editor_message_id !== record.editor_message_id)
                }
                if (mode) {
                    setSelectedRowKeys(select_temp)
                    setSelectedRowsInfo(selectRow)
                }
                else {
                    setcheckSelectedRowKeys(select_temp)
                    setcheckSelectedRowsInfo(selectRow)
                    onCheckSelectChange(select_temp, selectRow)
                }
            },
            getCheckboxProps: (record) => ({
                // disabled: record.pass === null,
            }),
        };

        const onFormFinish = (values) => {
            if (!values?.announce_time_end || values?.announce_time_end === "Invalid Date") {
                values = {
                    ...values,
                    announce_time_end: null
                }
            }
            if (axiosMode === "post") {
                postEditorMessageData([values])
            }
            else if (axiosMode === "patch") {
                patchEditorMessageData([values])
            }
        }

        const onFinish = ({ axiosMode, status, values }) => {
            if (status === "success") {
                if (axiosMode === "post") {
                    message.success("新增成功")
                    actionRef.current.reloadAndRest();

                }
                else if (axiosMode === "patch") {
                    message.success("修改成功")
                    actionRef.current.reloadAndRest();

                }
                else if (axiosMode === "delete") {
                    message.success("刪除成功")
                    actionRef.current.reloadAndRest();
                    setSelectedRowKeys([])
                    setSelectedRowsInfo([])

                }
                setModalLoading(false)
                setModalOpen(false)
            }
            else if (status === "error") {
                if (axiosMode === "post") {
                    message.error("新增失敗")
                    actionRef.current.reloadAndRest();
                }
                else if (axiosMode === "patch") {
                    message.error("修改失敗")
                    actionRef.current.reloadAndRest();
                }
                else if (axiosMode === "delete") {
                    message.error("刪除失敗")
                    actionRef.current.reloadAndRest();
                }
                setModalLoading(false)
                setModalOpen(false)
            }
        }

        const onBefore = ({ axiosMode, status, values }) => {
            setModalLoading(true)
        }

        const [mode, setMode] = useState(propsMode ? propsMode : true)
        const [showColumns, setShowColumns] = useState(propsShowColumns ? propsShowColumns : ["editor_message_id", "editor_message", 'last_edit_time', 'option'])
        const columns = [
            {
                title: '編號',
                dataIndex: 'editor_message_id',
                key: 'editor_message_id',
            },
            {
                title: '訊息',
                dataIndex: 'editor_message',
                key: 'editor_message',
            },
            {
                title: '修改時間',
                dataIndex: 'last_edit_time',
                key: 'last_edit_time',
            },
        ];

        const {
            EditorMessageData,
            getEditorMessageData,
            postEditorMessageData,
            patchEditorMessageData,
            deleteEditorMessageData,
        } = useEditorMessage({
            onFinish,
            onBefore,
        })

        // useEffect(() => {
        //     getEditorMessageData()
        // }, [])

        const {
            check,
            setCheck,
            checkAll,
            setOrders,
            custom_filter_key,
        } = useTableColumnsCheck(columns)

        useEffect(() => {
            checkAll()
        }, [])

        return<>
            <Col span={24}>
                <Row>
                    <Col span={24}>
                        <ProTableOT
                            actionRef={actionRef}
                            columns={columns.filter((element) => {
                                return showColumns.includes(element.key)
                            })}
                            headerTitle={<></>}
                            check={check}
                            setCheck={setCheck}
                            rowKey={'editor_message_id'}
                            toolBarRender={() => [
                            ]}
                            manage_columns={false}
                            request={async (params = {}, sort, filter) => {
                                setAxiosMode("get")
                                let newParams = {
                                };
                                let order = setOrders(sort)
                                newParams = {
                                    ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                                    ...newParams,
                                    order,
                                    size: params.pageSize,
                                    cur_page: params.current,
                                    custom_filter_value: params.keyword ?? "",
                                    custom_filter_key: custom_filter_key
                                };
                                newParams = setParamsFilter({
                                    ...newParams,
                                });
                                setPageSize(params?.pageSize ?? 20)
                                return getEditorMessageData(newParams)
                            }}
                            rowSelection={{
                                type: 'checkbox',
                                selectedRowKeys: mode ? selectedRowKeys : checkSelectedRowKeys,
                                ...rowSelection,
                            }}
                            tableAlertRender={({
                                selectedRowKeys,
                                selectedRows,
                                // onCleanSelected,
                            }) => {
                                return (
                                    <Space size={24}>
                                        <span>
                                            已選擇 {selectedRowKeys.length} 項
                                            <a style={{ marginInlineStart: 8 }} onClick={onCleanSelected}>
                                                取消選擇
                                            </a>
                                        </span>
                                    </Space>
                                );
                            }}
                            propsUseData={() => {
                                return {
                                    postData: postEditorMessageData,
                                    patchData: patchEditorMessageData,
                                    deleteData: deleteEditorMessageData
                                }
                            }}
                            modalOpen={modalOpen}
                            setModalOpen={setModalOpen}
                            PropsPatchForm={<NewsForm />}
                            propsPatch
                            propsPost
                            propsDelete
                            formMode={true}
                        />
                    </Col>
                </Row>
            </Col>
        </>
    }
    const useTableColumnsCheck = (columns) => {
        const [check, setCheck] = useState([])
        const checkAll = () => {
            setCheck((pre) => {
                return columns
                    .filter((element) => !element.disabled)
                    .map((val) => val.key);
            });
        }
        const setOrders = (sorter) => {
            if (sorter) {
                let newOrders = Object.keys(sorter).map((key, index) => {
                    if (sorter[key] === "descend") {
                        return JSON.stringify({
                            column: key,
                            type: 'DESC'
                        })
                    }
                    else {
                        return JSON.stringify({
                            column: key,
                            type: 'ASC'
                        })
                    }

                })
                return newOrders
            }
            else {
                return []
            }
        }
        return {
            check,
            custom_filter_key: check,
            setCheck,
            checkAll,
            setOrders
        }
    }


    export default EditorMessage;
